import {PATHS} from '@/const/paths';
import {SERVICES} from '@/const/services';
import {envUtil} from '@/helper/env';
import {numUtil} from '@/helper/num';
import {langUtil} from '@/helper/lang';
import {loadSendBird} from '@/resource/js';
import {c2cApi} from '@/api/c2c';
import {P2PTradeDefaultUrlTypeLocalKey} from '../const';

const APP_ID = /^https?:\/\/(ea.)?phemex.com/.test(SERVICES.BASE_URL)
  ? 'D3FF3847-5305-4B8F-857E-12F5F82F1E8C'
  : /^http?:\/\/localhost:\d{4}/.test(SERVICES.BASE_URL)
  ? '2B075933-78C5-48EE-BE3D-706BE10B598B'
  : '19E9B608-3439-4D7F-A125-BDC8340EF2E1';
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substring(1).match(reg);
  if (r != null) {
    return encodeURI(r[2]);
  }
  return null;
}

export function userAvatarColor(userId) {
  const colors = {
    0: '#2A313D',
    1: '#4F46C8',
    2: '#0D3662',
    3: '#045A61',
    4: '#9F144E',
    5: '#265C2A',
    6: '#CC5723',
    7: '#131311',
    8: '#00909E',
    9: '#16549E',
  };
  const uid = ((userId || '') + '').toString();
  const len = uid.length;
  if (!len) {
    return colors[0];
  }
  return len === 1 ? colors[uid] : colors[uid.substring(len - 1, len)];
}

export function methodPrefixColor(name) {
  const colors = {
    0: '#ff7575',
    1: '#2dc100',
    2: '#f0bb10',
    3: '#a573fd',
    4: '#dd54ff',
  };
  return colors[(name || '').toLowerCase().substring(0, 1).charCodeAt() % 5];
}

/**
 * 获取付款方式的颜色配置
 * @typedef Param
 * @property {string} Param.fiat 法币。用于已知法币
 * @property {array} Param.temIds 模版ID[]。用于已知多个模版id时使用
 * @property {string} Param.temName 模版名称。用于单个模版且已知模版名称
 * @param {Param} param0
 * @returns
 */
export async function getPaymentMethodTemColor({fiat = '', temIds, temName = ''} = {}) {
  const query = {};
  if (fiat) {
    query.fiatCurrency = fiat;
  }
  if (temIds && temIds.length > 0) {
    query.ids = temIds;
  }
  if (temName) {
    query.name = temName;
  }
  const {data} = await c2cApi.getMethodTemplate(query);

  const templates = (data && data.payTemplates) || [];
  if (temIds) {
    return temIds.map((templateId) => ({templateId, color: findTemColor(templates, 'templateId', templateId)}));
  }
  if (temName) {
    return findTemColor(templates, 'payMethodName', temName);
  }
  return templates.map((tem) => ({...tem, color: convertTemColor(tem.remark)}));
}

export function convertTemColor(objStr) {
  try {
    const data = JSON.parse(objStr || null) || {};
    return data.color || '';
  } catch {
    return '';
  }
}

export function findTemColor(templates, key, value) {
  const tem = templates.find((tem) => tem[key] === value);
  if (!tem) {
    return '';
  }
  return convertTemColor(tem.remark);
}

export function convertRate(rateEv) {
  const rate = numUtil.floor(rateEv, 2, 2);
  return rate ? rate + '%' : '';
}

export function setP2PTradeDefaultUrlLocal(type = 'express') {
  localStorage.setItem(P2PTradeDefaultUrlTypeLocalKey, type);
}

export function getP2PTradeDefaultUrlLocal(isLogin, fixLink) {
  if (envUtil.isServer) {
    return;
  }
  const localType = localStorage.getItem(P2PTradeDefaultUrlTypeLocalKey);
  if (!localType || localType === 'express') {
    return fixLink(isLogin ? PATHS.P2P_HOME_LOGIN.pathname : PATHS.P2P_HOME.pathname);
  }
  return fixLink(PATHS.P2P_HOME_MARKET.pathname);
}

export function replaceP2PHome(isLogin, fixLink) {
  window.location.replace(getP2PTradeDefaultUrlLocal(isLogin, fixLink));
}

export async function chatConnect({imUserId, sessionToken}) {
  try {
    if (!imUserId || !sessionToken) {
      throw Error('missing token');
    }
    await loadSendBird();
    const sb = new window.SendBird({appId: APP_ID, localCacheEnabled: true});
    await sb.connect(imUserId, sessionToken);
    return sb;
  } catch (e) {
    throw Error(e);
  }
}

export function printFileFormat(name) {
  if (!name) {
    return '';
  }
  const word = /\.(doc|docx)$/i.test(name);
  const excel = /\.(xls|xlsx)$/i.test(name);
  const pdf = /\.(pdf)$/i.test(name);
  const txt = /\.(txt)$/i.test(name);
  const fileTypes = {
    word: 'word',
    excel: 'excel',
    pdf: 'pdf',
    txt: 'txt',
  };
  if (word) {
    return fileTypes.word;
  }
  if (excel) {
    return fileTypes.excel;
  }
  if (pdf) {
    return fileTypes.pdf;
  }
  if (txt) {
    return fileTypes.txt;
  }
  return name;
}

export function isImg(name) {
  if (!name) {
    return '';
  }
  return /\.(png|jpg|jpeg|bmp|gif)$/i.test(name);
}

export function getUiPosition() {
  const {pathname} = langUtil.parsePathname(window.location.pathname);
  const uiPositionMap = {
    [PATHS.P2P_HOME_LOGIN.pathname]: 'express',
    [PATHS.P2P_HOME_MARKET.pathname]: 'p2p_trading',
    [PATHS.P2P_MAKER_HOME.pathname]: 'maker_advertiser',
  };
  return uiPositionMap[pathname] || '';
}

export function getTradeType(adDetail) {
  return adDetail.side === 'Buy' ? 'Sell' : adDetail.side === 'Sell' ? 'Buy' : '';
}
